export const highlightOption = function(truncateFilter) {
  return function(input, regex, length) {
    if (!input) return null;
    var text = truncateFilter(input, length || 9999);
    return text.replace(regex, "<span class='ac-highlight'>$&</span>");
  };
};

highlightOption.$inject = ['truncateFilter'];
